module.exports = __webpack_public_path__ + "static/media/background.f577433b.jpg";